<div class="timer">
    <p [class.blinking]="isBlinking">{{timeInDate | date:'mm:ss'}}</p>
</div>

